export default __webpack_public_path__ + "static/media/pink.01215631.jpg";